import { useDispatch, useSelector } from 'modules/react-redux';
import { useCallback } from 'react';

import { cancelActivePopup } from '../../actions';
import { XERO_ACCRUAL_REPORT_POPUP_ID } from '../../reducers/page/xeroAccrualReportPopupReducer';
import { getActivePopup } from '../../selectors/pageSelectors';

export const useXeroAccrualReportPopup = () => {
    const dispatch = useDispatch();
    const activePopupId = useSelector((state) => getActivePopup(state)?.id || null);

    const handleClose = useCallback(
        (open: boolean) => {
            if (!open) {
                dispatch(cancelActivePopup());
            }
        },
        [dispatch]
    );

    return {
        isOpen: activePopupId === XERO_ACCRUAL_REPORT_POPUP_ID,
        handleClose,
    };
};
